import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ColoradoRoute from './views/ColoradoRoute.vue'
import Foottracks from './views/Foottracks.vue'
import Works from './views/Works.vue'
import Peintures from './views/Peintures.vue'
import Installations from './views/Installations.vue'
import LatestWalkabouts from './views/LatestWalkabouts.vue'
import ColoradoSounds from './views/ColoradoSounds.vue'
import Galleries from './views/Galleries.vue'
import Contact from './views/Contact.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/colorado-route',
      name: 'ColoradoRoute',
      component: ColoradoRoute
    },
    {
      path: '/foottracks',
      name: 'Foottracks',
      component: Foottracks
    },
    {
      path: '/works',
      name: 'Works',
      component: Works
    },
    {
      path: '/works/peintures',
      redirect: to => {
        return { name: 'Peintures', params: { tab: '1980 - 1990' } }
      }
    },
    {
      path: '/works/peintures/:tab?',
      name: 'Peintures',
      component: Peintures
    },
    {
      path: '/works/installations',
      redirect: { name: 'Installations', params: { tab: 'quanash-86' } }
    },
    {
      path: '/works/installations/:tab?',
      name: 'Installations',
      component: Installations
    },

    {
      path: '/latest-walkabouts',
      name: 'LatestWalkabouts',
      component: LatestWalkabouts
    },
    {
      path: '/colorado-sounds',
      name: 'ColoradoSounds',
      component: ColoradoSounds
    },
    {
      path: '/colorado-sounds/galleries/:tab?',
      name: 'Galleries',
      component: Galleries
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }
  ]
})
